import React from 'react';

export const ProductAllocation = ({lineItem}) => {
    return <div>
        <div className="flex flex-row flex-between">
            <span className="section-sub-header-color fBold fs-16">
                Product Allocation
            </span>
        </div>
        <div className="flex pv-20 border-bottom-light flex-between flex-middle" >
            <div className="flex flex-1">
                <span className="section-sub-header-color fBold fs-14 op-5">
                    Product
                </span>
            </div>
            <div className="flex flex-1">
                <span className="section-sub-header-color fBold fs-14 op-5 pl-15">
                    Task Allocation(%)
                </span>
            </div>
        </div>
        {
            lineItem.product_allocation.map((product, index) => {
                return <div className="flex pv-20 border-bottom-light flex-between flex-middle" key={index}>
                    <div className="flex flex-1">
                        <span className="section-sub-header-color fs-14">
                         {product.name}
                        </span>
                    </div>
                    <div className="flex flex-1">
                        <span className="section-sub-header-color fs-14 ml-20">
                            {product.current}
                        </span>
                    </div>
                </div>
            })
        }
    </div>
}